function waitForProductRecommendations(callback) {
  const target = document.body;

  const observer = new MutationObserver((mutationsList, observer) => {
    const recommendations = document.querySelector('product-recommendations');
    if (recommendations) {
      observer.disconnect();
      callback();
    }
  });

  observer.observe(target, {
    childList: true,
    subtree: true,
  });
}

if (!customElements.get('product-card-information-sel')) {
  waitForProductRecommendations(() => {
    customElements.define(
      'product-card-information-sel',
      class ProductCardInfoSel extends HTMLElement {
        quantityInput = undefined;
        quantityForm = undefined;
        onVariantChangeUnsubscriber = undefined;
        cartUpdateUnsubscriber = undefined;
        abortController = undefined;
        pendingRequestUrl = null;
        preProcessHtmlCallbacks = [];
        postProcessHtmlCallbacks = [];

        constructor() {
          super();
          this.init();
        }

        init() {
          if (
            !this.querySelector('select[data-color-selector]') ||
            !this.querySelector('[data-variant-select]')
          ) {
            requestAnimationFrame(() => this.init());
            return;
          }

          this.colorSelect = this.querySelector('select[data-color-selector]');
          this.colorInputs = this.colorSelect.options;
          this.colorInputArray = Array.from(this.colorInputs);

          this.hiddenVariantSelect = this.querySelector('[data-variant-select]');
          this.hiddenVariantSelectArray = Array.from(this.hiddenVariantSelect.options);

          const updateActiveVariant = () => {
            const selectedColor = Array.from(this.colorInputs).find(input => input.selected);
            if (!selectedColor) return;

            const selectedVariantOption = Array.from(this.hiddenVariantSelect.options).find(option =>
              option.dataset['option-1'] === selectedColor.value
            );

            const buyButtonInput = this.querySelector(`.js-add-to-cart .product-variant-id`);
            const buyButton = this.querySelector(`.js-add-to-cart .product-form__submit`);

            if (selectedVariantOption) {
              const available = selectedVariantOption.dataset.available === "true";
              const newPrice = selectedVariantOption.dataset.price;

              buyButton.disabled = !available;
              buyButtonInput.value = selectedVariantOption.value;
              this.hiddenVariantSelect.value = selectedVariantOption.value;

              // const formattedPrice = "$" + Shopify.formatMoney(newPrice);
              const formattedPrice = Shopify.formatMoney(newPrice);
              this.querySelectorAll('[data-price-regular]').forEach(item => {
                item.innerText = formattedPrice;
              });
            }
          };

          this.colorSelect.addEventListener('change', updateActiveVariant);

          // Встановлюємо активний варіант одразу
          updateActiveVariant();
        }

        setUnavailable() {
          this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

          const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
            .map(id => `#${id}-${this.dataset.section}`)
            .join(', ');
          document.querySelectorAll(selectors).forEach(el => el.classList.add('hidden'));
        }

        updateVariantSelect() {
          const selectedOptions = Array.from(this.optionSelectors).map(select => select.value);
          const matchingVariant = Array.from(this.variantSelect.options).find(option =>
            option.text.includes(selectedOptions.join(' / '))
          );

          if (matchingVariant) {
            this.variantSelect.value = matchingVariant.value;
            const buyButton = this.querySelector(`.js-add-to-cart .product-variant-id`);
            buyButton.value = matchingVariant.value;
          }
        }

        resetProductFormState() {
          const productForm = this.productForm;
          productForm?.toggleSubmitButton(true);
          productForm?.handleErrorMessage();
        }

        updateProductInfo(variantId, variantPrice, variantAvailable) {
          const buyButton = this.querySelector(`.js-add-to-cart .product-variant-id`);
          buyButton.value = variantId;

          const formattedPrice = Shopify.formatMoney(variantPrice);
          this.querySelectorAll('[data-price-regular]').forEach(item => {
            item.innerText = formattedPrice;
          });
        }

        get productForm() {
          return this.querySelector(`product-form`);
        }

        get pickupAvailability() {
          return this.querySelector(`pickup-availability`);
        }

        get variantSelectors() {
          return this.querySelector(`#${this.id} variant-selects`);
        }

        get sectionId() {
          return this.dataset.originalSection || this.dataset.section;
        }
      }
    );
  });
}
